import React from 'react';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-bootstrap';


function StatutCandidatureArbitrage(props) {

  return (
    <>

    {props.status && props.status.id_arbitre === props.userData.user.donnée.results[0].id && 
        <>
          <Card.Header></Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Card.Text>Votre candidature pour arbitrer {props.status.equipe_dom} - {props.status.equipe_ext} est : <strong>{props.status.status}  </strong>. </Card.Text>
              <Form.Label>Le commentaire du club</Form.Label>
              <Form.Control disabled as="textarea" value={props.status.commentaire_club} rows={3}  />
              <Form.Label>Votre commentaire</Form.Label>
              <Form.Control disabled as="textarea" value={props.status.commentaire_arbitre} rows={3}  />
            </Form.Group>
          </Card.Body> 
        </>
    }


    </>
  );
}

export default StatutCandidatureArbitrage;